<template>
<div>

	<div class="page-header">
		<h1 v-if="!isLoading">
            <template v-if="!section.id"><lang labelKey="SECTION-HEADER-NEW_SECTION"></lang></template>
            <template v-else>Rubrik: {{ section.name }}</template>
        </h1>
	</div>

	<div class="columns">

		<div class="col-main">

			<template v-if="isLoading">
				<div class="loadingContainer has-text-centered">
					<loading-indicator></loading-indicator>
				</div>
			</template>

            <template v-else>

                <div class="box">

                    <div class="control is-horizontal">
                        <div class="control-label">
                            <label-name labelKey="SECTION-NAME"></label-name>
                        </div>
                        <div class="control">
                            <input id="SECTION-NAME" class="input is-medium" type="text" v-model="section.name">
                        </div>
                    </div>

					<div class="control is-horizontal">
                        <div class="control-label">
                            <label-name labelKey="SECTION-TOPICNAME"></label-name>
                        </div>
                        <div class="control">
                            <input id="SECTION-TOPICNAME" class="input is-medium" type="text" v-model="section.topicName">
                        </div>
                    </div>

					<div class="control is-horizontal">

						<div class="control-label">
							<label-name labelKey="SECTION-TYPE"></label-name>
						</div>

						<div class="control">
							<span class="select is-medium">
								<select id="SECTION-TYPE" v-model="section.type" :disabled="userRole=='Redaktion'">
									<!-- <option :value="null">{{ $t('SELECT_BOX-SECTION_TYPE') }}</option> -->
									<option v-for="sectionType in catalogSectionTypes" :value="sectionType.id">
										{{ $t('SELECT_BOX-SECTION_TYPE-' + sectionType.name) }}
									</option>
								</select>
							</span>
						</div>

					</div>


                    <div class="control is-horizontal">
                        <div class="control-label">
                            <label-name labelKey="SECTION-COLOR"></label-name>
                        </div>
                        <div class="control">
                            <input id="SECTION-COLOR" class="input is-medium" type="text" v-model="section.color">
                        </div>
                    </div>

                </div>

            </template>


        </div>

        <div class="col-aside">

            <div class="sidebox">
                <affix :offset="0" boundary=".col-aside">
                    <!--<custom-button type="blue" icon="fa-save" name="SECTION-BTN_SAVE" :loading="isSaving" @click.native="submitForm"></custom-button>-->
					<custom-button type="blue" icon="icon-ak-speichern" name="SECTION-BTN_SAVE" :loading="isSaving" @click.native="submitForm"></custom-button>
                </affix>
            </div>


        </div>

    </div>

</div>

</template>


<script>
export default {

	data() {

		return {
            isLoading: false,
            isSaving: false,
            section: {}
        }

    },

	computed: {

		catalogSectionTypes() {
			// console.log("types: ", this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CONTENT_CATEGORIES'));
			return this.$store.getters.getTermsByTaxonomy('CATALOG_SECTION_TYPES');
		}

	},

	created() {

        var sectionId = parseInt(this.$route.params.sectionID);

        if (sectionId && Number.isInteger(sectionId)) {
            this.entityGet('catalogSection', sectionId, {}, 'section');
        }

    },


    methods: {

        submitForm() {

            var self = this;

            this.entityCreateOrUpdate('catalogSection', this.section)
                .then(function() {

                    // self.$router.push({ path: '/einstellungen/rubriken' });
										self.$router.push({ name: 'settingsSections' });

                });
        }

    }


}

</script>


<style>


</style>
